<template>
  <div class="footer">
    <img src="~images/2nd-logo.svg" alt="" />
    <p>F1 Miami &#8211; Formula 1™ Miami Grand Prix © {{ currentYear }}</p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  background-color: $color-secondary;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    margin-block: 1em;
  }
  p {
    font-family: Formula1-Display-Bold;
    color: $color-secondary-dark;
    font-size: 0.55rem;
    opacity: 0.5;
  }
}
</style>
